import { cn } from '@up2stay/up2promo-ui';
import { LockKeyhole } from 'lucide-react';

interface ProfileFieldLockedHintProps {
  locked: boolean;
  message: string;
  className?: string;
}

export function ProfileFieldLockedHint({
  locked,
  message,
  className,
}: ProfileFieldLockedHintProps) {
  if (!locked) return null;

  return (
    <p
      className={cn(
        'flex items-center gap-1.5 text-xs text-muted-foreground',
        className,
      )}
    >
      <LockKeyhole className="h-3.5 w-3.5 shrink-0" aria-hidden />
      <span>{message}</span>
    </p>
  );
}
